"use client";

import { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
import { Locale } from '@/lib/i18n/config';

export const useRTL = () => {
  const params = useParams();
  const locale = (params?.locale as Locale) || 'en';
  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    // Arabic and Persian are RTL languages
    const rtlLanguages = ['ar', 'fa'];
    const isRtl = rtlLanguages.includes(locale);

    setIsRTL(isRtl);

    // Update document direction and language
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = locale;

    // Add/remove RTL class to body for additional styling if needed
    if (isRtl) {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [locale]);

  return { isRTL };
};
